<div
  [className]="
    'skymiles-landing-section__container__pagination
     skymiles-landing-section__container__pagination__actions--' +
    (paginator.actions ? 'true' : 'false')
  "
>
  <!-- Previous action -->
  <a
    href="javascript:void(0)"
    [class]="
      createActionClass(
        paginator.index,
        'previous',
        paginator.actions,
        paginator.count
      )
    "
    (click)="updateIndex(paginator.index, 'previous')"
    role="button"
  >
    <span *ngIf="paginator.ariaLabels.action" class="sr-only">
      {{ paginator.ariaLabels.action.previous }}
    </span>
    <img
      [class]="
        'skymiles-landing-section__container__pagination__previous-action--icon' +
        ' skymiles-landing-section__container__pagination__previous-action--icon' +
        (paginator.actions ? '' : '--no-text')
      "
      [alt]=""
    />
    <div
      *ngIf="paginator.actions"
      class="skymiles-landing-section__container__pagination__previous-action--text"
    >
      {{ paginator.actions.previous }}
    </div>
  </a>
  <!-- Horizontal bars -->
  <div
    [class]="
      'skymiles-landing-section__container__pagination__bars' +
      ' skymiles-landing-section__container__pagination__bars' +
      (paginator.actions ? '' : '--no-text')
    "
    [style]="{
      'grid-template-columns': 'repeat(' + paginator.count + ', max-content)'
    }"
  >
    <a
      href="javascript:void(0)"
      (click)="updateIndex(paginator.index, 'bar', i)"
      *ngFor="let bar of getCountArray(); let i = index"
      [className]="
        'skymiles-landing-section__container__pagination__bars__indicators
        skymiles-landing-section__container__pagination__bars__indicators--' +
        (paginator.index === i) +
        ' skymiles-landing-section__container__pagination__bars__indicators--' +
        (paginator.index === i) +
        (paginator.actions ? '' : '--no-text')
      "
      role="button"
    >
      <span class="sr-only">{{ paginator.ariaLabels.title[i] }}</span>
    </a>
  </div>
  <!-- title and label -->
  <div
    *ngIf="paginator.label"
    class="skymiles-landing-section__container__pagination__label"
  >
    <div class="skymiles-landing-section__container__pagination__label__title">
      {{ paginator.label.title }}
    </div>
    <div
      class="skymiles-landing-section__container__pagination__label__subtitle"
    >
      {{ paginator.label.subtitle }}
    </div>
  </div>
  <!-- Next action -->
  <a
    href="javascript:void(0)"
    (click)="updateIndex(paginator.index, 'next')"
    [class]="
      createActionClass(
        paginator.index,
        'next',
        paginator.actions,
        paginator.count
      )
    "
    role="button"
  >
    <span *ngIf="paginator.ariaLabels.action" class="sr-only">
      {{ paginator.ariaLabels.action.next }}
    </span>
    <div
      *ngIf="paginator.actions"
      class="skymiles-landing-section__container__pagination__next-action--text"
    >
      {{ paginator.actions.next }}
    </div>
    <img
      [class]="
        'skymiles-landing-section__container__pagination__next-action--icon' +
        ' skymiles-landing-section__container__pagination__next-action--icon' +
        (paginator.actions ? '' : '--no-text')
      "
      class="skymiles-landing-section__container__pagination__next-action--icon"
      [alt]=""
    />
  </a>
</div>
